import React from "react";

function TruckIcon() {
    return (
        <svg
            viewBox="0 0 34.246 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="translate(0 -67.004)">
                <g transform="translate(0 67.004)">
                    <path
                        transform="translate(0 -67.004)"
                        d="M33.084,77.7l-2.332-1.009-1.98-3.853a3.118,3.118,0,0,0-2.806-1.705h-3.41v-.963A3.146,3.146,0,0,0,19.421,67H3.12A3.138,3.138,0,0,0,0,70.169V84.926a1.922,1.922,0,0,0,1.9,1.95h.436c0,.076-.008.107-.008.153a3.961,3.961,0,0,0,7.921.031v-.038a1.189,1.189,0,0,0-.008-.153H23.412v.153a3.961,3.961,0,1,0,7.921.031V86.86h.986a1.928,1.928,0,0,0,1.927-1.927V79.474A1.917,1.917,0,0,0,33.084,77.7ZM6.293,89.482a2.431,2.431,0,1,1,2.431-2.431A2.428,2.428,0,0,1,6.293,89.482Zm14.733-4.121H9.879a3.955,3.955,0,0,0-7.172,0h-.78a.4.4,0,0,1-.4-.421V81h19.5Zm0-15.184v9.3H1.53v-9.3a1.609,1.609,0,0,1,1.59-1.636h16.3a1.62,1.62,0,0,1,1.606,1.629Zm1.529,2.493h3.41a1.614,1.614,0,0,1,1.453.864l1.529,2.959H22.555ZM27.38,89.482a2.431,2.431,0,1,1,2.431-2.431A2.428,2.428,0,0,1,27.38,89.482Zm5.344-4.542a.4.4,0,0,1-.4.421H30.966a3.958,3.958,0,0,0-7.172,0H22.555v-7.34h7.493l2.431,1.07a.45.45,0,0,1,.245.413Z"
                    />
                </g>
            </g>
        </svg>
    );
}

export default TruckIcon;
